import bg_left_opportunity from '../../Assets/bg_left_opportunity.png'
import bg_right_opportunity from '../../Assets/bg_right_opportunity.png'
import card_1_opportunity from '../../Assets/card_1_opportunity.png'
import card_2_opportunity from '../../Assets/card_2_opportunity.png'
import card_3_opportunity from '../../Assets/card_3_opportunity.png'
import * as S from './OpportunitySection.styles'

export const OpportunitySection = () => {
  return (
    <S.Wrapper id='Opportunity'>
      <S.SideBg
        src={bg_left_opportunity}
        alt="bg_opportunity"
        style={{ left: '0', bottom: '-150px' }}
      />

      <S.WrapperContent style={{ zIndex: '10' }}>
        <S.WrapperContentH1>
          A Digital Payment Revolution You Can’t Ignore
        </S.WrapperContentH1>

        <S.WrapperContentP>
          Brazil is moving fast. PIX is the real-time payment method adopted by over 140 million people, unlocking untapped growth for global businesses. With PayQuest, international partners can now accept payins directly from Brazilian customers — with ease and compliance.
        </S.WrapperContentP>

        <S.CardsBox>

          <S.Card
            style={{
              boxShadow: '0 0 40px rgba(217, 249, 39, 0.15)'
            }}
          >
            <img src={card_1_opportunity} alt="card_1_opportunity" />

            <div>
              <S.Cardh6>3B+</S.Cardh6>

              <S.Cardp>PIX Transactions/month</S.Cardp>
            </div>
          </S.Card>

          <S.Card
            style={{
              boxShadow: '0 0 40px rgba(217, 249, 39, 0.15)'
            }}
          >
            <img src={card_2_opportunity} alt="card_2_opportunity" />
            <div>
              <S.Cardh6>140M+</S.Cardh6>

              <S.Cardp>Users Connected</S.Cardp>
            </div>
          </S.Card>

          <S.Card
            style={{
              boxShadow: '0 0 40px rgba(217, 249, 39, 0.15)'
            }}
          >
            <img src={card_3_opportunity} alt="card_3_opportunity" />

            <div>
              <S.Cardh6>24/7</S.Cardh6>

              <S.Cardp>Settlements</S.Cardp>
            </div>
          </S.Card>

        </S.CardsBox>

      </S.WrapperContent>
      <S.SideBg
        src={bg_right_opportunity}
        alt="bg_opportunity"
        style={{ right: '0', top: '300px' }}
      />


    </S.Wrapper>
  )
}
